import type { CustomerRegistrationResponseFragment } from '@/graphql/api'
import { useRouterNavigation } from '@/plugins/released-urls/useRouterNavigation'
import { useAuth } from '@/plugins/auth.ts'

export type ResponseData = {
    customer?: CustomerRegistrationResponseFragment
}

export function useHandleFormSubmitResponse(redirectToRoute: string) {
    const { setAuth, setLoginMessage } = useAuth()
    const { routerPush } = useRouterNavigation()

    const handleFormSubmitResponse = (
        data: ResponseData,
        redirect?: string | null
    ) => {
        if (data.customer) {
            setAuth(data.customer.login)
        } else {
            // TODO Translate
            setLoginMessage(
                "We've added this enquiry to your existing account."
            )
        }

        if (redirect) {
            routerPush(redirect).catch(() => {
                //
            })
        } else {
            routerPush({ name: redirectToRoute }).catch(() => {
                //
            })
        }
    }

    return { handleFormSubmitResponse }
}
